var map = {
	"./1.jpg": "8554",
	"./10.jpg": "efcc",
	"./2.jpg": "405a",
	"./3.jpg": "11d9",
	"./4.jpg": "bafb",
	"./5.jpg": "4d0f",
	"./6.jpg": "06d4",
	"./7.jpg": "32a5",
	"./8.jpg": "15ea",
	"./9.jpg": "6d96",
	"./businesses-kahon1-min.jpg": "ae13"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";